import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api";

export const fetchSlider = createAsyncThunk(
  "home/fetchSlider",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("home/sliders/");
      const data = res.data;

      if (Array.isArray(data)) {
        return data;
      } else if (data?.results && Array.isArray(data.results)) {
        return data.results;
      } else {
        console.warn("Unexpected slider data format:", data);
        return [];
      }
    } catch (err) {
      console.error("Slider load error:", err);
      return rejectWithValue(err.response?.data || "Failed to load slider");
    }
  }
);

export const fetchBanners = createAsyncThunk(
  "home/fetchBanners",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("home/banners/");
      const data = res.data;

      if (Array.isArray(data)) {
        return data;
      } else if (data?.results && Array.isArray(data.results)) {
        return data.results;
      } else {
        console.warn("Unexpected banners data format:", data);
        return [];
      }
    } catch (err) {
      console.error("Banner load error:", err);
      return rejectWithValue(err.response?.data || "Failed to load banners");
    }
  }
);

export const fetchProducts = createAsyncThunk(
  "home/fetchProducts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("shop/products/");
      const data = res.data;

      if (Array.isArray(data)) {
        return data;
      } else if (data?.results && Array.isArray(data.results)) {
        return data.results;
      } else {
        console.warn("Unexpected products data format:", data);
        return [];
      }
    } catch (err) {
      console.error("Products load error:", err);
      return rejectWithValue(err.response?.data || "Failed to load products");
    }
  }
);

const homeSlice = createSlice({
  name: "home",
  initialState: {
    slider: [],
    loading: false,
    error: null,

    banners: [],
    bannersLoading: false,
    bannersError: null,

    products: [],
    productsLoading: false,
    productsError: null,
  },

  reducers: {
    clearHomeState: (state) => {
      state.slider = [];
      state.banners = [];
      state.products = [];
      state.loading = false;
      state.error = null;
      state.bannersLoading = false;
      state.bannersError = null;
      state.productsLoading = false;
      state.productsError = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchSlider.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSlider.fulfilled, (state, action) => {
        state.loading = false;
        state.slider = action.payload || [];
      })
      .addCase(fetchSlider.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });

    builder
      .addCase(fetchBanners.pending, (state) => {
        state.bannersLoading = true;
        state.bannersError = null;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.bannersLoading = false;
        state.banners = action.payload || [];
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.bannersLoading = false;
        state.bannersError = action.payload || action.error.message;
      });

    builder
      .addCase(fetchProducts.pending, (state) => {
        state.productsLoading = true;
        state.productsError = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.productsLoading = false;
        state.products = action.payload || [];
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.productsLoading = false;
        state.productsError = action.payload || action.error.message;
      });
  },
});

export const { clearHomeState } = homeSlice.actions;
export default homeSlice.reducer;
